<template>
  <v-row>
    <v-col
      v-for="project in projectsList"
      :key="project.id"
      cols="12"
      md="6"
      lg="4"
      xl="3"
    >
      <ProjectCard
        :project="project"
        :deletable="deletePermitted"
        @delete="confirmDeleteProject"
      />
    </v-col>
  </v-row>
</template>

<script>
import ProjectCard from '@/components/Projects/ProjectCard.vue';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  components: {
    ProjectCard,
  },

  computed: {
    ...mapState('projects', ['projectsList']),
    ...mapGetters('auth', ['checkUserPermissions']),

    deletePermitted() {
      const availability = ['admin_director', 'chief'];
      return this.checkUserPermissions(availability);
    },
  },
  methods: {
    ...mapActions('projects', [
      'softDeleteProject',
      'deleteProjectPermanently',
    ]),

    ...mapActions('dialog', [
      'showDialog',
      'clearDialog',
    ]),

    confirmDeleteProject(project) {
      if (project.status === 'Wersja robocza') {
        this.confirmPermanentDeleteProject(project.id);
        } else {
        this.confirmSoftDeleteProject(project.id);
      }
    },

    confirmSoftDeleteProject(id) {
      this.showDialog({
        header: 'Usuwanie projektu',
        text: '<b>Czy na pewno chcesz przenieść ten projekt do kosza?</b>',
        component: 'Confirm',
        props: {
          confirmText: 'Przenieś',
          rejectText: 'Nie przenoś',
        },
      })
        .then(() => {
          this.softDeleteProject(id).then(() => {
            this.$emit('fetch');
          });
        })
        .catch(() => {
          this.clearDialog();
        });
    },

    confirmPermanentDeleteProject(id) {
      this.showDialog({
        header: 'Trwałe usuwanie projektu',
        text: 'Czy na pewno chcesz trwale usunąć projekt?',
        component: 'Confirm',
        props: {
          confirmText: 'Usuń',
          rejectText: 'Nie usuwaj',
        },
      })
        .then(() => {
          this.deleteProjectPermanently(id).then(() => {
            this.$emit('fetch');
          });
        })
        .catch(() => {
          this.clearDialog();
        });
    },
  },
};
</script>
